import { CollectionPageData } from "../types/schema.types";
import {
  generateCollectionPage,
  CollectionPageOptions,
} from "../utils/schema-generators";

/**
 * Builds Schema.org CollectionPage structured data
 * @param collectionPageData - Collection page information for schema generation
 * @param options - Optional copyright and publisher metadata
 * @returns CollectionPage-shaped object (without @context — injector handles that)
 */
export function buildCollectionPageSchema(
  collectionPageData: CollectionPageData,
  options?: CollectionPageOptions
): Record<string, unknown> {
  return generateCollectionPage(
    collectionPageData.name,
    collectionPageData.description,
    collectionPageData.url,
    collectionPageData.inLanguage,
    collectionPageData.breadcrumbs,
    options
  );
}
